import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';

export interface StaffListItem {
  userId: string;
  firstName: string;
  lastName: string;
  role: string;
}

export async function listStaffUsers(): Promise<StaffListItem[]> {
  try {
    const response = await apiClient.get<ApiResponse<StaffListItem[]>>('/auth/staff');
    return response.data;
  } catch {
    return [];
  }
}
